
// Photoswipe & Gallery
var productGalleryImagesSelector = '.product-gallery-images';
var productGalleryThumbnailsSelector = '.product-gallery-thumbnails';

// Photoswipe
var lightbox = new PhotoSwipeLightbox({
    gallery: '.product-gallery-images.has-lightbox', //productGalleryImagesSelector,
    children: 'a',
    // dynamic import is not supported in UMD version
    pswpModule: PhotoSwipe 
});

lightbox.init();


// Product Gallery 
var productGalleryImagesList = document.querySelectorAll(productGalleryImagesSelector);

productGalleryImagesList.forEach(productGalleryImages => {
    
    // if( productGalleryImages.querySelectorAll('a').length > 1 ){
    if( productGalleryImages.classList.contains('splide') ){

        productGalleryImages.querySelectorAll('a').forEach(image => {
            image.addEventListener('click', function(e){
                e.preventDefault();
            })
        })


        let productGalleryOptions = {};
        
        if (productGalleryImages.dataset.options) {
            productGalleryOptions = JSON.parse(productGalleryImages.dataset.options);
        }

        productGalleryOptions['classes'] = {
            // Add classes for arrows.
            arrows: 'splide__arrows',
            arrow : 'splide__arrow',
            prev  : 'splide__arrow--prev',
            next  : 'splide__arrow--next'
        };


        var main = new Splide(productGalleryImages, productGalleryOptions);
    

        var productGalleryThumbnails = productGalleryImages.closest('.product-gallery').querySelector(productGalleryThumbnailsSelector);

        if( productGalleryThumbnails ){

            productGalleryThumbnails.querySelectorAll('a').forEach(thumb => {
                thumb.addEventListener('click', function(e){
                    e.preventDefault();

                })
            })

            let productThumbnailsOptions = {};
            let productGalleryThumbnailsSize = productGalleryThumbnails.querySelectorAll('.splide__slide').length; 
            
            if (productGalleryThumbnails.dataset.options) {
                productThumbnailsOptions = JSON.parse(productGalleryThumbnails.dataset.options);
            }

            productThumbnailsOptions['classes'] = {
                // Add classes for arrows.
                arrows: 'splide__arrows',
                arrow : 'splide__arrow',
                prev  : 'splide__arrow--prev',
                next  : 'splide__arrow--next'
            };

            
            productThumbnailsOptions['slideFocus'] = true;
            productThumbnailsOptions['pagination'] = false;
            productThumbnailsOptions['direction'] = 'ttb';
            productThumbnailsOptions['height'] = '430px';
            productThumbnailsOptions['perPage'] = 1;
            productThumbnailsOptions['perMove'] = 1;
            // productThumbnailsOptions['isNavigation'] = true;

            productThumbnailsOptions['dragMinThreshold'] = {
                mouse: 4,
                touch: 10,
            };
            productThumbnailsOptions['breakpoints'] = {
                768: {
                    direction: 'ltr',
                    height: 'auto'
                },
            };

            if( productGalleryThumbnailsSize < 4 ){
                productThumbnailsOptions['height'] = 'auto';
            }

            // console.log("productGalleryThumbnails", productGalleryThumbnails, productThumbnailsOptions);
            var thumbnails = new Splide(productGalleryThumbnails, productThumbnailsOptions);
        }

        thumbnails.mount();
        main.sync( thumbnails );
        main.mount();


        main.on( 'inactive', function (slideComponent) {
            
            var slide = slideComponent.slide;

            var slideVideo = slide.querySelector('video');
            var slideIframe = slide.querySelector('iframe');
            if( slideVideo ){
                slideVideo.pause();
            }

            if( slideIframe ){
                // Pausing Youtube video
                slideIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')

                // Pausing Vimeo video
                slideIframe.contentWindow.postMessage('{"method":"pause"}', '*');
            }

        } );

        productGalleryThumbnails.querySelectorAll('li').forEach((thumb) => {

            thumb.addEventListener('click', function(){

                var thumbnailIndex = parseInt(thumb.dataset.thumbnailIndex);

                if(thumbnailIndex){
                    main.go(thumbnailIndex - 1);
                }
            })
            thumb.addEventListener('keyup', function(event){

                if (event.key === 'Enter') {
                    thumb.click();
                }
            })
        })
            
    }
});


class ProductGallery extends HTMLElement{
    constructor(){
        super();

        this.productGalleryImagesListItems = this.querySelectorAll('.product-gallery-images:not(.splide) .product-gallery-images-image');
        
        for( let item of this.productGalleryImagesListItems ){
            item.addEventListener('click', function(e){
                e.preventDefault();

                // It will scroll the image to display in the viewport.
                item.scrollIntoView({ behavior: "smooth" });
            })
        }
        
    }
}
customElements.define('product-gallery', ProductGallery)


// Product Rich media
class ProductRichMedia extends HTMLElement{
    constructor(){
        super();

        this.mediaPreview = this.querySelector('.product-rich-media-preview');
        this.mediaContent = this.querySelector('.product-rich-media-content');
        this.video = this.querySelector('video');
        this.modelViewer = this.querySelector('model-viewer');
        this.xrButton = this.querySelector('.product-xr-button');

        this.mediaPreview.addEventListener('click', () => {
            this.onClick();
        })

        if(this.xrButton){
            this.xrButton.addEventListener('click', () => {
                this.xrButtonClick();
            })
        }


        // this.modelViewer.addEventListener('click', (e) => {
        //     // var modelViewer = e.target.closest('model-viewer')
        //     // Shopify.loadFeatures(
        //     //     [
        //     //         {
        //     //             name: 'model-viewer-ui',
        //     //             version: '1.0',
        //     //             onLoad: (errors) => this.initiateModelViewerUI(errors, modelViewer)
        //     //         }
        //     //     ]
        //     // )
        // })

    }

    onClick = () => {

        this.classList.add('active');

        // this.mediaContent.dispatchEvent(new Event('click'));

        if( this.video ){
            this.video.play();
        }

        if( this.modelViewer ){

            this.loadModelInteraction();
        }

    }

    xrButtonClick = () => {
        console.log("clicked xr")


        Shopify.loadFeatures(
            [
                {
                    name: 'shopify-xr',
                    version: '1.0',
                    onLoad: (errors) => this.setupShopifyXR(errors),
                }
            ]
        )
    }

    loadModelInteraction = () => {

        Shopify.loadFeatures(
            [
                {
                    name: 'model-viewer-ui',
                    version: '1.0',
                    onLoad: (errors) => this.initiateModelViewerUI(errors)
                }
            ]
        )
    }

    initiateModelViewerUI = (errors) => {
        if (errors){
            return false
        }

        this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'))
    }

    setupShopifyXR = (errors) => {
        if (errors) {
            return false
        }


        if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () =>
            this.setupShopifyXR()
            );
            return;
        }

        const modelJSON = this.xrButton.dataset.shopifyModel3dContent
    
        // console.log(this.xrButton.dataset.shopifyModel3dContent)
        // document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
            window.ShopifyXR.addModels(JSON.parse(modelJSON));
        //   modelJSON.remove();
        // });
        window.ShopifyXR.setupXRElements();
      }


}
customElements.define('product-rich-media', ProductRichMedia)


// Collapsible row
class productCollapsibleRow extends HTMLElement{
    constructor(){
        super();

        this.detectDefaultTab();

        this.querySelector('.product-collapsible-row__title').addEventListener('click', (event) => {
            this.onClick(event);
        })
        
    }

    detectDefaultTab = () => {
        if( this.classList.contains('active_by_default') ){
            var collapsibleContent = this.querySelector('.product-collapsible-row__content');
            var collapsibleContentHeight = collapsibleContent.offsetHeight;
            collapsibleContent.style.height = collapsibleContentHeight + 'px';
            this.classList.remove('active_by_default');
        }   
    }

    onClick = (event) => {

        var productCollapsibleRow = this.closest('product-collapsible-row');
        var collapsibleContent = productCollapsibleRow.querySelector('.product-collapsible-row__content');
        var collapsibleContentHeight = collapsibleContent.offsetHeight;

        if( productCollapsibleRow.classList.contains('active') ){
            collapsibleContent.style.removeProperty('height');
            setTimeout(function(){
                productCollapsibleRow.classList.remove('active');
            }, 200)
        }
        else{
            productCollapsibleRow.classList.add('active');
            setTimeout(function(){
                collapsibleContent.style.height = collapsibleContentHeight + 'px';
            }, 10)
        }
    }

}
customElements.define('product-collapsible-row', productCollapsibleRow)



// Information popup
class ProductInfoPopup extends HTMLElement{
    constructor(){
        super();

        this.productInfoButtons = this.querySelectorAll('.product-info-popup__button');




        for(let productInfoButton of this.productInfoButtons){
            productInfoButton.addEventListener('click', (event) => {
                if( !event.target.closest('popup-modal')){
                    this.onClick(event, productInfoButton);
                }
            })
        }
    }

    onClose = () => {
        var popupModal = document.querySelector('.popup-modal');

        if(popupModal.classList.contains('product-info-popup-modal')) {
            popupModal.classList.remove('product-info-popup-modal');
        }

        popupModal.querySelector('.popup-modal__content').innerHTML = '';
    }
    

    onClick = (event, infoButton) => {
        event.preventDefault();

        var pageHandle = event.target.dataset.pageHandle; 


        this.classList.add('loading');


        var popupModal = document.querySelector('.popup-modal');

        if( !popupModal ){
            var quickviewModalString = `<popup-modal class="popup-modal product-info-popup-modal">
            <div class="popup-modal__overlay"></div>
            <div class="popup-modal__inner">
                <div class="popup-modal__content">
                </div>
                <button class="popup-modal__close">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="1.11092" y1="0.610962" x2="8.88909" y2="8.38914" stroke="currentColor" stroke-linecap="round"/>
                        <line x1="1.11096" y1="8.38915" x2="8.88914" y2="0.610971" stroke="currentColor" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
            </popup-modal>
                          `
            var quickviewModal = new DOMParser().parseFromString(quickviewModalString, 'text/html').querySelector('popup-modal')

            document.body.append(quickviewModal);
        }
        else{
            if(!popupModal.classList.contains('product-info-popup-modal')) {
                popupModal.classList.add('product-info-popup-modal');
            }

            popupModal.classList.remove('inactive');
        }

        if( !pageHandle ){

            var emptyText = infoButton.dataset.emptyText;

            if( emptyText ){

                var infoButtonWrap = document.createElement('div');
                infoButtonWrap.classList.add('page-description');
                infoButtonWrap.innerHTML = emptyText;

                var popupModalContent = document.querySelector('.popup-modal__content');
                popupModalContent.append(infoButtonWrap);
            }

            return false
        }

        // fetch(`${window.Shopify.routes.root}pages/${pageHandle}?section_id=popup-modal`)
        fetch(`${window.Shopify.routes.root}pages/${pageHandle}`)
            .then((response) => {
                // console.log("res", response)
                if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                }

                return response.text();
            })
            .then((res)=>{ 

                // console.log("res", res)
                var html = new DOMParser().parseFromString(res, 'text/html');
                var content = html.querySelector('.section-main-page-content');
                // console.log("html", content);

                var popupModalContent = document.querySelector('.popup-modal__content');
                popupModalContent.append(content);



                this.popupCloseButton = document.querySelector('.popup-modal__close');
                this.popupOverlay = document.querySelector('.popup-modal__overlay');

                
                this.popupCloseButton.addEventListener('click', () => {
                    this.onClose();
                })

                this.popupOverlay.addEventListener('click', () => {
                    this.onClose();
                })

            })

    }


}
customElements.define('product-info-popup', ProductInfoPopup);


// Share product
class ProductShareIcons extends HTMLElement{
    constructor(){
        super();

        // Copy Share Link
        this.copyShareLink();

        // Share icons
        this.shareIcons();

    }

    copyShareLink = () => {
        var shareCopyLink = this.querySelector('.product-share-copy-link > a');

        shareCopyLink.addEventListener('click', (event) => {
            event.preventDefault();
    
            navigator.clipboard.writeText(shareCopyLink.getAttribute('href')).then(()=>{ 
                shareCopyLink.parentElement.classList.add('copied')
    
                setTimeout(function(){
                    shareCopyLink.parentElement.classList.remove('copied')
                }, 3000)
            });
    
        })
    }

    shareIcons = () => {
        var shareIcons = this.querySelectorAll('.product-share-icon > a');

        for(let icon of shareIcons){
            icon.addEventListener('click', (event) => {
                event.preventDefault();

                var url = icon.getAttribute('href');
                window.open(url, 'popUpWindow', 'height=700, width=800, left=10, top=10, resizable=yes, scrollbars=yes, toolbar=yes, menubar=no, location=no, directories=no, status=yes');

            })
        }
    }

}
customElements.define('product-share-icons', ProductShareIcons)
// var shareCopyLink = document.querySelectorAll('.product-share-copy-link > a');

// for(let link of shareCopyLink){
//     link.addEventListener('click', (event) => {
//         event.preventDefault();

//         navigator.clipboard.writeText(link.getAttribute('href')).then(()=>{ 
//             link.parentElement.classList.add('copied')

//             setTimeout(function(){
//                 link.parentElement.classList.remove('copied')
//             }, 3000)
//         });

//     })
// }

// var shareIcon = document.querySelectorAll('.product-share-icon > a');
// for(let icon of shareIcon){
//     icon.addEventListener('click', (event) => {
//         event.preventDefault();

//         var url = icon.getAttribute('href');
//         window.open(url, 'popUpWindow', 'height=700, width=800, left=10, top=10, resizable=yes, scrollbars=yes, toolbar=yes, menubar=no, location=no, directories=no, status=yes');

//     })
// }


// Product recommendation
class ProductRecommendations extends HTMLElement{
    constructor(){
        super();

        var splideArrows = this.querySelector('.splide__arrows');
        var splideProgress = this.querySelector('.splide__progress');
        
        var productId = this.dataset.productId
        var intent = this.dataset.intent
        var limit = this.dataset.limit

        // var sectionId = this.dataset.sectionId;
        var columnsCount = parseInt(this.dataset.columnsCount);
        var carousel = this.dataset.carousel === 'true';
        var columnsOffset = this.dataset.columnsOffset === 'true';
        var carouselOptions = JSON.parse(this.dataset.options);

        // if( sectionId.length == 0 ){
        //     sectionId = 'product-recommendations'
        // }

        fetch(window.Shopify.routes.root + `recommendations/products?product_id=${productId}&section_id=product-recommendations&limit=${limit}&intent=${intent}`)
            .then(response => response.text())
            .then((text) => {
                // console.log("res", text)

                var html = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
                // console.log("res dom", html)


                var productsList = html.querySelector('ul');
                var products = html.querySelectorAll('.product');

                if( products.length > columnsCount && carousel ){

                    var productsListWrap = document.createElement('div');

                    for (const className of productsList.classList) {
                        productsListWrap.classList.add(className)

                    }

                    for (const product of products){
                        product.classList.add('splide__slide')
                    }

                    productsListWrap.classList.add('has-carousel');
                    productsListWrap.classList.add('splide');


                    var splideTrack = document.createElement('div');

                    splideTrack.classList.add('splide__track');


                    productsList.classList.add('splide__list');
                    productsList.classList.remove('product-recommendations-list');


                    splideTrack.appendChild(productsList);

                    productsListWrap.appendChild(splideTrack);
                    productsListWrap.appendChild(splideArrows);

                    if(splideProgress){
                        productsListWrap.appendChild(splideProgress);
                    }
                    
                    // console.log("products list wrap", productsListWrap);
                    // carouselOptions = {};


                    if(columnsOffset){
                        productsListWrap.classList.add('has-carousel-columns-offset');

                        carouselOptions['autoWidth'] = true
                    }

                    carouselOptions['classes'] = {
                        // Add classes for arrows.
                        arrows: 'splide__arrows',
                        arrow : 'splide__arrow',
                        prev  : 'splide__arrow--prev',
                        next  : 'splide__arrow--next',
                
                        // // Add classes for pagination.
                        // pagination: 'splide__pagination your-class-pagination', // container
                        // page      : 'splide__pagination__page your-class-page', // each button
                    };
                    
                    const splide = new Splide(productsListWrap, carouselOptions);

                    var splideBar = splide.root.querySelector( '.splide__progress-bar' );

                    if( splideBar ){
                        // Updates the bar width whenever the carousel moves:
                        splide.on( 'mounted move', function () {
                            var end  = splide.Components.Controller.getEnd() + 1;
                            var rate = Math.min( ( splide.index + 1 ) / end, 1 );
                            splideBar.style.width = String( 100 * rate ) + '%';
                        } );
                    }

                    splide.mount();
                    
                    this.appendChild(productsListWrap)

                }
                else{

                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('.shopify-section');
                    
                    if( recommendations ){
                        this.innerHTML = recommendations.innerHTML;
                    }

                }

                const productsLazyloadImages = this.querySelectorAll('.lazy-loading-image');

                productsLazyloadImages.forEach(imageContainer => {
                    lazyloading(imageContainer);
                })

            });
    }
}

customElements.define('product-recommendations', ProductRecommendations)



// Recipient Form
class RecipientForm extends HTMLElement{
    constructor(){
        super();

        this.recipientToggle = this.querySelector('.recipient-form-toggle');

        this.recipientToggle.addEventListener('click', (e) => {
            e.preventDefault();
            //.dispatchEvent('click');

            this.onClick();
        })
   
    // let productAddToCartSelector = '.product-add-to-cart';
    // let productAddToCart = event.target.closest(productAddToCartSelector);

    // if( productAddToCart && !productAddToCart.hasAttribute('disabled') ){
    //     event.preventDefault();

    // }

        // this.productForm = document.querySelector('.product-options-form');

        // var productAddToCart = this.productForm.closest(productAddToCartSelector)
     
        // if( productAddToCart ){
        //     productAddToCart.addEventListener('click', (e) => {
        //         // e.preventDefault();
        //         console.log("i reached submit")

        //         this.onSubmit();
        //     })
        // }
        
    }


    onClick = () => {

        var recipientForm = this.closest('.recipient-form');
        var recipientFormToggleInput = this.recipientToggle.querySelector('input');
        var recipientFormFields = recipientForm.querySelector('.recipient-form-fields');
        var recipientFormFieldsHeight = recipientFormFields.offsetHeight;

        // console.log("checked", this.querySelector('input').getAttribute('checked'));

        // this.querySelector('input').setAttribute('checked', !this.querySelector('input').getAttribute('checked'));

        if( recipientFormToggleInput.getAttribute('checked') ){
            recipientFormToggleInput.removeAttribute('checked')
        }
        else{
            recipientFormToggleInput.setAttribute('checked', true)
        }

        if( recipientForm.classList.contains('active') ){
            recipientFormFields.style.removeProperty('height');
            setTimeout(function(){
                recipientForm.classList.remove('active');
            }, 200)
        }
        else{
            recipientForm.classList.add('active');
            setTimeout(function(){
                recipientFormFields.style.height = recipientFormFieldsHeight + 'px';
            }, 10)
        }
    }

    onSubmit = () => {

        console.log("I run this before submit");

        this.productForm.submit();

    }
    
}
customElements.define('recipient-form', RecipientForm)

// Sticky add to cart

class StickyBar extends HTMLElement {
  constructor() {
    super();

    this.product = this.closest('.product');

    if (!this.product) return;

    this.lastSelection = '';
    this.lastVariantId = '';

    this.stickyAddToCart = this.querySelector(
      '.product-sticky-bar-add-to-cart'
    );

    // Sticky Add to Cart → trigger main Add to Cart
    if (this.stickyAddToCart) {
      this.stickyAddToCart.addEventListener('click', (event) => {
        event.preventDefault();

        const mainButton = this.getMainAddToCart();

        if (mainButton && !mainButton.disabled) {
          mainButton.click();
        }
      });
    }

    // Listen to color / size changes
    this.product.addEventListener(
      'change',
      () => {
        this.scheduleSync();
      },
      true
    );

    this.product.addEventListener(
      'click',
      (event) => {
        if (
          event.target.closest(
            'input[type="radio"], label'
          )
        ) {
          this.scheduleSync();
        }
      },
      true
    );

    // Refine variant event
    document.addEventListener(
      'shopifyProductVariantFetched',
      () => {
        this.scheduleSync();
      }
    );

    // Reliable fallback watcher
    this.variantWatcher = setInterval(() => {
      const selection = this.getSelection();
      const variantId = this.getCurrentVariantId();

      if (
        selection !== this.lastSelection ||
        variantId !== this.lastVariantId
      ) {
        this.syncStickyBar();
      }
    }, 100);

    // Sticky visibility
    this.handleScroll = () => {
      const mainButton = this.getMainAddToCart();
      const footer = document.querySelector('.section-footer');

      if (!mainButton || !footer) return;

      const buttonTop =
        mainButton.getBoundingClientRect().top;

      const footerTop =
        footer.getBoundingClientRect().top;

      if (
        buttonTop < 0 &&
        footerTop > window.innerHeight
      ) {
        this.classList.add('active');
      } else {
        this.classList.remove('active');
      }
    };

    window.addEventListener(
      'scroll',
      this.handleScroll,
      { passive: true }
    );

    // Initial sync
    setTimeout(() => {
      this.syncStickyBar();
    }, 300);
  }


  // ============================================
  // SELECTED COLOR + SIZE
  // ============================================

  getSelection() {
    const colorInput = this.product.querySelector(
      'input[name^="Color-"]:checked'
    );

    const sizeInput = this.product.querySelector(
      'input[name^="Shoe size-"]:checked'
    );

    const color = colorInput
      ? colorInput.value.trim()
      : '';

    const size = sizeInput
      ? sizeInput.value.trim()
      : '';

    return [color, size]
      .filter(Boolean)
      .join(' / ');
  }


  // ============================================
  // CURRENT SHOPIFY VARIANT ID
  // ============================================

  getCurrentVariantId() {
    const inputs = this.product.querySelectorAll(
      'form[action*="/cart/add"] input[name="id"]'
    );

    for (const input of inputs) {
      const value = String(
        input.value || ''
      ).trim();

      if (
        value &&
        value !== 'none' &&
        /^\d+$/.test(value)
      ) {
        return value;
      }
    }

    // URL fallback
    const urlVariant =
      new URL(window.location.href)
        .searchParams
        .get('variant');

    return urlVariant || '';
  }


  // ============================================
  // SYNC WITH SMALL DELAYS
  // ============================================

  scheduleSync() {
    this.syncStickyBar();

    setTimeout(() => {
      this.syncStickyBar();
    }, 80);

    setTimeout(() => {
      this.syncStickyBar();
    }, 200);

    setTimeout(() => {
      this.syncStickyBar();
    }, 400);
  }


  // ============================================
  // MAIN SYNC
  // ============================================

  syncStickyBar() {
    const selection = this.getSelection();
    const variantId = this.getCurrentVariantId();

    this.lastSelection = selection;
    this.lastVariantId = variantId;

    this.updateVariantTitle(selection);
    this.updatePrice();
    this.updateThumbnail(variantId);
    this.updateButton();
  }


  // ============================================
  // VARIANT TITLE
  // White Blue / 7
  // ============================================

  updateVariantTitle(selection) {
    const stickyVariant = this.querySelector(
      '.product-sticky-bar-chosen-variant'
    );

    if (
      stickyVariant &&
      selection
    ) {
      stickyVariant.textContent = selection;
    }
  }


  // ============================================
  // PRICE
  // ============================================

  updatePrice() {
    const stickyPrice = this.querySelector(
      '.product-sticky-bar-product-price'
    );

    if (!stickyPrice) return;

    const prices = Array.from(
      this.product.querySelectorAll(
        '.product-price'
      )
    );

    const mainPrice = prices.find(
      (price) =>
        !price.closest('sticky-bar')
    );

    if (mainPrice) {
      stickyPrice.innerHTML =
        mainPrice.innerHTML;
    }
  }


  // ============================================
  // PRODUCT IMAGE
  // ============================================

  updateThumbnail(variantId) {
    const stickyThumbnail = this.querySelector(
      '.product-sticky-bar-product-thumbnail'
    );

    if (!stickyThumbnail) return;

    // First try Refine variant image mapping
    if (variantId) {
      const thumbnails =
        this.product.querySelectorAll(
          '.product-gallery-thumbnails-thumbnail'
        );

      for (const thumbnail of thumbnails) {
        const ids = String(
          thumbnail.dataset.variantIds || ''
        );

        if (
          ids.includes(
            String(variantId)
          )
        ) {
          stickyThumbnail.innerHTML =
            thumbnail.innerHTML;

          return;
        }
      }
    }

    // Fallback → selected color swatch image
    const colorInput =
      this.product.querySelector(
        'input[name^="Color-"]:checked'
      );

    if (
      !colorInput ||
      !colorInput.id
    ) {
      return;
    }

    const colorLabel =
      this.product.querySelector(
        `label[for="${CSS.escape(
          colorInput.id
        )}"]`
      );

    if (!colorLabel) return;

    const swatchImage =
      colorLabel.querySelector('img');

    if (!swatchImage) return;

    const stickyImage =
      stickyThumbnail.querySelector('img');

    if (stickyImage) {
      stickyImage.src =
        swatchImage.currentSrc ||
        swatchImage.src;

      if (swatchImage.srcset) {
        stickyImage.srcset =
          swatchImage.srcset;
      } else {
        stickyImage.removeAttribute(
          'srcset'
        );
      }
    } else {
      stickyThumbnail.innerHTML = '';

      stickyThumbnail.appendChild(
        swatchImage.cloneNode(true)
      );
    }
  }


  // ============================================
  // MAIN ADD TO CART
  // ============================================

  getMainAddToCart() {
    const buttons = Array.from(
      this.product.querySelectorAll(
        '.product-add-to-cart'
      )
    );

    return buttons.find(
      (button) =>
        !button.closest('sticky-bar')
    );
  }


  // ============================================
  // ADD TO CART / SOLD OUT
  // ============================================

  updateButton() {
    const mainButton =
      this.getMainAddToCart();

    const stickyButton =
      this.querySelector(
        '.product-sticky-bar-add-to-cart'
      );

    if (
      !mainButton ||
      !stickyButton
    ) {
      return;
    }

    stickyButton.disabled =
      mainButton.disabled;

    // Copy button text/status
    if (mainButton.innerHTML) {
      stickyButton.innerHTML =
        mainButton.innerHTML;
    }

    this.classList.toggle(
      'product-currently-not-available',
      mainButton.disabled
    );
  }


  // ============================================
  // CLEANUP
  // ============================================

  disconnectedCallback() {
    if (this.variantWatcher) {
      clearInterval(
        this.variantWatcher
      );
    }

    if (this.handleScroll) {
      window.removeEventListener(
        'scroll',
        this.handleScroll
      );
    }
  }
}


customElements.define(
  'sticky-bar',
  StickyBar
);


// =====================================================
// REFINE STICKY CART - LIVE VARIANT SYNC FIX
// =====================================================

(function () {
  if (window.__refineStickyVariantSync) return;
  window.__refineStickyVariantSync = true;

  let lastVariantId = null;
  let lastVariantTitle = null;

  function getMainProduct() {
    const sticky = document.querySelector('sticky-bar');

    if (sticky) {
      const product = sticky.closest('.product');

      if (product) {
        return product;
      }
    }

    return document.querySelector('.product');
  }


  function getStickyBar() {
    return document.querySelector(
      'sticky-bar.product-sticky-bar'
    );
  }


  function getVariantId(product) {
    if (!product) return null;

    /*
     * Shopify's real Add to Cart variant ID.
     * Your console confirmed this changes correctly.
     */
    const inputs = product.querySelectorAll(
      'form[action*="/cart/add"] input[name="id"]'
    );

    for (const input of inputs) {
      const value = String(
        input.value || ''
      ).trim();

      if (
        value &&
        value !== 'none' &&
        /^\d+$/.test(value)
      ) {
        return value;
      }
    }

    /*
     * URL fallback
     */
    return new URL(window.location.href)
      .searchParams
      .get('variant');
  }


  function getSelectedOptions(product) {
    if (!product) return [];

    const radios = Array.from(
      product.querySelectorAll(
        'input[type="radio"]:checked'
      )
    );

    return radios
      .filter((input) => {
        if (input.closest('sticky-bar')) {
          return false;
        }

        const name = String(
          input.name || ''
        ).toLowerCase();

        /*
         * Ignore unrelated radios.
         */
        if (
          name.includes('selling_plan') ||
          name.includes('recipient') ||
          name.includes('quantity')
        ) {
          return false;
        }

        return true;
      })
      .map((input) => {
        /*
         * First use actual radio value.
         */
        let value = String(
          input.value || ''
        ).trim();

        if (value) {
          return value;
        }

        /*
         * Fallback to label text.
         */
        if (input.id) {
          const label =
            product.querySelector(
              `label[for="${CSS.escape(input.id)}"]`
            );

          if (label) {
            value =
              label.textContent.trim();
          }
        }

        return value;
      })
      .filter(Boolean);
  }


  function getMainPrice(product) {
    if (!product) return null;

    const prices = Array.from(
      product.querySelectorAll(
        '.product-price'
      )
    );

    return prices.find(
      (element) =>
        !element.closest('sticky-bar')
    );
  }


  function getMainAddToCart(product) {
    if (!product) return null;

    const buttons = Array.from(
      product.querySelectorAll(
        '.product-add-to-cart'
      )
    );

    return buttons.find(
      (button) =>
        !button.closest('sticky-bar')
    );
  }


  function updateStickyTitle(
    sticky,
    selectedOptions
  ) {
    const title = sticky.querySelector(
      '.product-sticky-bar--chosen-variant'
    );

    if (
      !title ||
      !selectedOptions.length
    ) {
      return;
    }

    const newTitle =
      selectedOptions.join(' / ');

    if (
      title.textContent.trim() !== newTitle
    ) {
      title.textContent = newTitle;
    }
  }


  function updateStickyPrice(
    product,
    sticky
  ) {
    const mainPrice =
      getMainPrice(product);

    const stickyPrice =
      sticky.querySelector(
        '.product-sticky-bar--product-price'
      );

    if (
      mainPrice &&
      stickyPrice
    ) {
      stickyPrice.innerHTML =
        mainPrice.innerHTML;
    }
  }


  function updateStickyButton(
    product,
    sticky
  ) {
    const mainButton =
      getMainAddToCart(product);

    const stickyButton =
      sticky.querySelector(
        '.product-sticky-bar--add-to-cart'
      );

    if (
      !mainButton ||
      !stickyButton
    ) {
      return;
    }

    stickyButton.disabled =
      mainButton.disabled;

    sticky.classList.toggle(
      'product-currently-not-available',
      mainButton.disabled
    );
  }


  function updateStickyImage(
    product,
    sticky,
    variantId
  ) {
    if (!variantId) return;

    const stickyThumbnail =
      sticky.querySelector(
        '.product-sticky-bar--product-thumbnail'
      );

    if (!stickyThumbnail) return;

    /*
     * Refine gallery thumbnails contain
     * variant mapping information.
     */
    const thumbnails =
      product.querySelectorAll(
        '.product-gallery-thumbnails-thumbnail'
      );

    for (const thumbnail of thumbnails) {
      const ids = String(
        thumbnail.dataset.variantIds || ''
      );

      if (
        ids.includes(
          String(variantId)
        )
      ) {
        stickyThumbnail.innerHTML =
          thumbnail.innerHTML;

        return;
      }
    }


    /*
     * Fallback:
     * get image from checked swatch.
     */
    const checkedRadios =
      product.querySelectorAll(
        'input[type="radio"]:checked'
      );

    for (const input of checkedRadios) {
      if (!input.id) continue;

      const label =
        product.querySelector(
          `label[for="${CSS.escape(input.id)}"]`
        );

      if (!label) continue;

      const image =
        label.querySelector('img');

      if (!image) continue;

      const stickyImage =
        stickyThumbnail.querySelector(
          'img'
        );

      if (stickyImage) {
        stickyImage.src =
          image.currentSrc ||
          image.src;

        if (image.srcset) {
          stickyImage.srcset =
            image.srcset;
        }
      }

      return;
    }
  }


  function syncStickyCart() {
    const product =
      getMainProduct();

    const sticky =
      getStickyBar();

    if (
      !product ||
      !sticky
    ) {
      return;
    }

    const variantId =
      getVariantId(product);

    const selectedOptions =
      getSelectedOptions(product);

    const variantTitle =
      selectedOptions.join(' / ');

    /*
     * Don't do unnecessary DOM writes.
     */
    if (
      variantId === lastVariantId &&
      variantTitle === lastVariantTitle
    ) {
      return;
    }

    lastVariantId =
      variantId;

    lastVariantTitle =
      variantTitle;


    updateStickyTitle(
      sticky,
      selectedOptions
    );


    /*
     * Refine may update price/gallery slightly
     * after the option selection.
     */
    setTimeout(() => {
      const latestProduct =
        getMainProduct();

      const latestSticky =
        getStickyBar();

      if (
        !latestProduct ||
        !latestSticky
      ) {
        return;
      }

      const latestVariantId =
        getVariantId(latestProduct);

      updateStickyPrice(
        latestProduct,
        latestSticky
      );

      updateStickyButton(
        latestProduct,
        latestSticky
      );

      updateStickyImage(
        latestProduct,
        latestSticky,
        latestVariantId
      );
    }, 80);


    setTimeout(() => {
      const latestProduct =
        getMainProduct();

      const latestSticky =
        getStickyBar();

      if (
        !latestProduct ||
        !latestSticky
      ) {
        return;
      }

      updateStickyPrice(
        latestProduct,
        latestSticky
      );

      updateStickyImage(
        latestProduct,
        latestSticky,
        getVariantId(latestProduct)
      );

      updateStickyButton(
        latestProduct,
        latestSticky
      );
    }, 300);
  }


  /*
   * Listen globally instead of attaching
   * events to Refine's replaceable product DOM.
   */
  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target.closest('.product')
      ) {
        setTimeout(
          syncStickyCart,
          0
        );
      }
    },
    true
  );


  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target.closest(
          '.product input, .product label'
        )
      ) {
        setTimeout(
          syncStickyCart,
          20
        );

        setTimeout(
          syncStickyCart,
          150
        );

        setTimeout(
          syncStickyCart,
          400
        );
      }
    },
    true
  );


  /*
   * Most reliable fallback.
   *
   * Even if Refine replaces the DOM,
   * this always queries the NEW elements.
   */
  setInterval(
    syncStickyCart,
    150
  );


  /*
   * Initial load
   */
  setTimeout(
    syncStickyCart,
    300
  );

})();





// =====================================================
// STICKY CART - FORCE LIVE VARIANT SYNC
// =====================================================

(function () {
  let lastSelection = '';

  function updateStickyCart() {
    const stickyBar = document.querySelector(
      'sticky-bar.product-sticky-bar'
    );

    if (!stickyBar) return;

    const product = stickyBar.closest('.product');

    if (!product) return;

    // Get selected Color
    const colorInput = product.querySelector(
      'input[name^="Color-"]:checked'
    );

    // Get selected Shoe size
    const sizeInput = product.querySelector(
      'input[name^="Shoe size-"]:checked'
    );

    const color = colorInput
      ? colorInput.value
      : '';

    const size = sizeInput
      ? sizeInput.value
      : '';

    const selection = [color, size]
      .filter(Boolean)
      .join(' / ');

    // Stop if nothing has changed
    if (
      !selection ||
      selection === lastSelection
    ) {
      return;
    }

    lastSelection = selection;

    console.log(
      'Sticky cart updating:',
      selection
    );

    // =========================
    // UPDATE VARIANT TEXT
    // =========================

    const stickyVariant =
      stickyBar.querySelector(
        '.product-sticky-bar--chosen-variant'
      );

    if (stickyVariant) {
      stickyVariant.textContent =
        selection;
    }


    // =========================
    // UPDATE PRICE
    // =========================

    const mainPrices =
      product.querySelectorAll(
        '.product-price'
      );

    const mainPrice =
      Array.from(mainPrices).find(
        (element) =>
          !element.closest('sticky-bar')
      );

    const stickyPrice =
      stickyBar.querySelector(
        '.product-sticky-bar--product-price'
      );

    if (
      mainPrice &&
      stickyPrice
    ) {
      stickyPrice.innerHTML =
        mainPrice.innerHTML;
    }


    // =========================
    // UPDATE BUTTON
    // =========================

    const mainButtons =
      product.querySelectorAll(
        '.product-add-to-cart'
      );

    const mainButton =
      Array.from(mainButtons).find(
        (button) =>
          !button.closest('sticky-bar')
      );

    const stickyButton =
      stickyBar.querySelector(
        '.product-sticky-bar--add-to-cart'
      );

    if (
      mainButton &&
      stickyButton
    ) {
      stickyButton.disabled =
        mainButton.disabled;

      stickyBar.classList.toggle(
        'product-currently-not-available',
        mainButton.disabled
      );
    }


    // =========================
    // UPDATE IMAGE
    // =========================

    if (colorInput) {
      const colorLabel =
        colorInput.id
          ? product.querySelector(
              `label[for="${CSS.escape(
                colorInput.id
              )}"]`
            )
          : null;

      const swatchImage =
        colorLabel?.querySelector('img');

      const stickyImage =
        stickyBar.querySelector(
          '.product-sticky-bar--product-thumbnail img'
        );

      if (
        swatchImage &&
        stickyImage
      ) {
        stickyImage.src =
          swatchImage.currentSrc ||
          swatchImage.src;

        if (swatchImage.srcset) {
          stickyImage.srcset =
            swatchImage.srcset;
        }
      }
    }
  }


  // ============================================
  // DIRECT RADIO CHANGE
  // ============================================

  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target.matches(
          'input[name^="Color-"], input[name^="Shoe size-"]'
        )
      ) {
        setTimeout(
          updateStickyCart,
          0
        );

        setTimeout(
          updateStickyCart,
          100
        );

        setTimeout(
          updateStickyCart,
          300
        );
      }
    },
    true
  );


  // ============================================
  // FALLBACK WATCHER
  //
  // This watches the actual checked options,
  // NOT Refine's missing variant <select>.
  // ============================================

  setInterval(() => {
    const stickyBar =
      document.querySelector(
        'sticky-bar.product-sticky-bar'
      );

    if (!stickyBar) return;

    const product =
      stickyBar.closest('.product');

    if (!product) return;

    const color =
      product.querySelector(
        'input[name^="Color-"]:checked'
      )?.value || '';

    const size =
      product.querySelector(
        'input[name^="Shoe size-"]:checked'
      )?.value || '';

    const currentSelection =
      [color, size]
        .filter(Boolean)
        .join(' / ');

    if (
      currentSelection &&
      currentSelection !== lastSelection
    ) {
      updateStickyCart();
    }
  }, 100);


  // Initial load
  setTimeout(
    updateStickyCart,
    500
  );
})();